<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>

    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Elegí la zona geográfica</h1>
    </div>

    <div class="p-2 pl-2 help" (click)="openhelp()"><i class="bi bi-info-circle"></i></div>
  </div>

  @if (helpOpen()) {
    <div class="row m-3 p-3 align-items-center" id="tooltip-pwa" style="display:flex;">
      <div class="col-auto"><i class="bi bi-info-circle" style="font-size: 1.8em;"></i></div>
      <div class="col">{{ helpText() }}</div>
      <div class="col-auto" (click)="openhelp()"><i class="bi bi-x-lg" style="font-size: 1.4em;"></i></div>
    </div>
  }

  <div class="row-cols-12 m-2">
    <form (ngSubmit)="saveZonaGeografica()" (keydown.enter)="$event.preventDefault()" [formGroup]="zonaGeografica">
      <div class="row-cols-12 p-2 input-group fade-in search-input-row">
        <div class="col-auto rounded-start" id="search-addon">
          <div class="mx-auto d-block p-1 d-inline-flex pt-1 ps-2"><i class="bi bi-search"></i></div>
        </div>

        <div class="col rounded">
          <input
            type="text"
            class="form-control search-input shadow-none"
            #inputPlaces
            id="inputPlaces"
            placeholder="Ingresa la dirección"
            aria-label="Search"
            aria-describedby="search-addon"
            formControlName="direccion" />
        </div>

        <a (click)="ubicacionActual()">
          <div class="col-auto rounded-end text-end" id="mic-addon">
            <div class="mx-auto d-block p-1 d-inline-flex"><i class="bi bi-geo-alt"></i></div>
          </div>
        </a>
      </div>

      <div class="mapa-wrapper position-relative">
        @if (loadingLocal()) {
          <div class="spinner-overlay fade-in">
            <div class="spinner-border text-info color-spinner" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        }

        <div class="row mb-4 mt-4 m-2 text-start">
          <div class="mapa" #divMap [class.mapa-opaco]="loadingLocal()"></div>
        </div>
      </div>

      @if (error()) {
        <div class="alert alert-danger mt-2" role="alert">
          <small>{{ error() }}</small>
        </div>
      }

      <div class="d-grid mt-5 mb-3 pb-3">
        <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loadingGlobal()">
          {{ loadingGlobal() ? 'Cargando...' : 'Siguiente' }}
        </button>
      </div>
    </form>
  </div>
</div>